/**
 * Format a South African phone number for display as `+27 XX XXX XXXX`.
 * Accepts inputs like `+27821234567`, `0821234567`, `+27 82 123 4567`, etc.
 * Returns the original string unchanged if it does not match the SA pattern.
 */
export function formatPhone(input) {
    if (!input)
        return '';
    const digits = input.replace(/\D/g, '');
    let national = null;
    if (digits.length === 11 && digits.startsWith('27')) {
        national = digits.slice(2);
    }
    else if (digits.length === 10 && digits.startsWith('0')) {
        national = digits.slice(1);
    }
    if (!national || national.length !== 9)
        return input;
    return `+27 ${national.slice(0, 2)} ${national.slice(2, 5)} ${national.slice(5)}`;
}
